import * as React from 'react';
import { IconButton } from '@cian/frontend-reviews-components';
import { IconSocialDislikeOn16, IconSocialLikeOn16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { setReviewReaction } from '../../../browser/services/reviews/setReviewReaction';
import { requestAuthentication } from '../../actions/authentication';
import { ReviewsReactions } from '../../components/ReviewsReactions';
import { getIsAuthenticated } from '../../selectors/user';
import { ILike } from '../../types/newbuilding/reviews';
import { useAppDispatch } from '../../hooks/useAppDispatch';

export interface IReviewsReactionsContainerProps {
  reviewId: string;
  reactions: ILike;
}

export const ReviewsReactionsContainer: React.FC<IReviewsReactionsContainerProps> = ({ reviewId, reactions }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);

  const setAnswerLike = React.useCallback(() => setReviewReaction({ reviewId, type: 'liked' }), []);
  const setAnswerDislike = React.useCallback(() => setReviewReaction({ reviewId, type: 'disliked' }), []);

  const onLikeClick = React.useCallback(() => {
    if (isAuthenticated) {
      dispatch(setAnswerLike());
    } else {
      dispatch(requestAuthentication({ onSuccess: setAnswerLike }));
    }
  }, [dispatch, isAuthenticated, setAnswerLike]);

  const onDislikedClick = React.useCallback(() => {
    if (isAuthenticated) {
      dispatch(setAnswerDislike());
    } else {
      dispatch(requestAuthentication({ onSuccess: setAnswerDislike }));
    }
  }, [dispatch, isAuthenticated, setAnswerDislike]);

  return (
    <ReviewsReactions
      like={
        <IconButton
          Icon={IconSocialLikeOn16}
          active={reactions.status === 'liked'}
          onClick={onLikeClick}
          label={reactions.likesCount}
        />
      }
      dislike={
        <IconButton
          Icon={IconSocialDislikeOn16}
          active={reactions.status === 'disliked'}
          onClick={onDislikedClick}
          label={reactions.dislikesCount}
        />
      }
    />
  );
};
